export const STORAGE_KEYS = {
  MARKET_DEPTH_FILTERS: 'marketDepth.filters',
  MARKET_DEPTH_CAPACITY_FILTERS: 'marketDepth.capacityFilters',
  MARKET_ACTIVITY_FILTERS: 'marketActivity.filters',
  MARKET_ACTIVITY_TAB: 'marketActivity.tab',
  MARKET_ACTIVITY_SYNC_POSITION: 'marketActivity.syncPosition',
  DASHBOARD_SELECTED_PROJECT_ID: 'dashboard.selectedProjectId',
  ADMIN_LAST_SECTION: 'admin.lastSection',
  ADMIN_COMPANIES_FILTER_MODEL: 'admin.companies.filterModel',
  ADMIN_COMPANIES_GRID_STATE: 'admin.companies.gridState',
  ADMIN_USERS_FILTER_MODEL: 'admin.users.filterModel',
  ADMIN_USERS_GRID_STATE: 'admin.users.gridState',
  ADMIN_AUDIT_SELECTED_TYPE: 'admin.audit.selectedType',
  ADMIN_AUDIT_ID_VALUE: 'admin.audit.idValue',
  ADMIN_AUDIT_GRID_STATE: 'admin.audit.gridState',
  ADMIN_BLOCK_TRADE_GRID_STATE: 'admin.blockTrade.gridState',
  ADMIN_COMPANY_USERS_GRID_STATE: 'admin.companyUsers.gridState',
  DASHBOARD_OFFERS_GRID_STATE: 'dashboard.offers.gridState',
  DASHBOARD_BIDS_GRID_STATE: 'dashboard.bids.gridState',
  TRANSACTIONS_CELEBRATED: 'transactions.celebrated',
} as const;
